import { sharedEnvironment } from '@vinnova/environments';

const etjansterCommonApiBaseURI = `${sharedEnvironment.utv.gatewayUrl}/etjanster`;

export const environment = {
  production: sharedEnvironment.utv.production,
  name: sharedEnvironment.utv.name,
  etjansterCommonUrl: sharedEnvironment.utv.etjansterCommonUrl,
  bpUrl: sharedEnvironment.utv.bpUrl,
  ansokanUrl: sharedEnvironment.utv.ansokanUrl,
  projektUrl: sharedEnvironment.utv.projektUrl,
  cookieDomain: sharedEnvironment.utv.cookieDomain,
  etjansterCommonApiUrl: etjansterCommonApiBaseURI,
  projektApiUrl: `${sharedEnvironment.utv.gatewayUrl}/projekt`,
  resourceStringUrl: `${sharedEnvironment.utv.gatewayUrl}/resourcestring/etjanstercommon`,
  externalLinks: sharedEnvironment.utv.externalLinks,
  redirectUrls: [
    sharedEnvironment.utv.bpUrl,
    sharedEnvironment.utv.etjansterCommonUrl,
    sharedEnvironment.utv.enkatRegisterUrl,
    sharedEnvironment.utv.oregUrl,
    sharedEnvironment.utv.ansokanUrl,
  ],
  baseGatewayUrl: sharedEnvironment.utv.gatewayUrl,
  apimSubscriptionKey: sharedEnvironment.utv.apimSubscriptionKey,
  chatbotApiUrl: `${etjansterCommonApiBaseURI}/chatbot`,
  b2cMsalConfig: {
    ...sharedEnvironment.b2cMsalConfig(
      etjansterCommonApiBaseURI,
      sharedEnvironment.utv.azureAdB2C.clientId.etjansterCommonClientId,
      sharedEnvironment.utv.azureAdB2C.clientId.etjansterCommonApiClientId,
    ),
    authority: sharedEnvironment.utv.azureAdB2C.authority,
    scope: `https://${sharedEnvironment.utv.azureAdB2C.tenant}.onmicrosoft.com/${sharedEnvironment.utv.azureAdB2C.clientId.etjansterCommonApiClientId}/all`,
    tenant: sharedEnvironment.utv.azureAdB2C.tenant,
    policies: sharedEnvironment.utv.azureAdB2C.policies,
    clientId: sharedEnvironment.utv.azureAdB2C.clientId,
  },
};
